import Advisors from 'components/Advisors/Advisors';
import BusinessModel from 'components/Benefits/BusinessModel';
import MissionStatement from 'components/HeroComponents/MissionStatement';
import Inquiry from 'components/Inquiry/Inquiry';
import LeadershipTeam from 'components/LeadershipTeam/LeadershipTeam';

const About = () => {
  return (
    <>
      <MissionStatement />
      <BusinessModel />
      <LeadershipTeam />
      <Advisors />
      <Inquiry />
    </>
  );
};

export default About;
